<ng-template #loading>
  <mat-spinner [diameter]="60" [strokeWidth]="4" [mode]="'indeterminate'"></mat-spinner>
</ng-template>

<ng-container *ngIf="!(loading$ | async); else loading">
  <mat-accordion multi="true">
    <!-- <div *ngFor="let item of items></div> -->
    <mat-list role="list">
      <app-item *ngFor="let item of items; let even = even; let odd = odd; trackBy: trackByFn;" [item]="item"
        [locale]="locale" [desktop]="desktop" [readOnly]="readOnly" [expandAll]="expandAll"
        [ngClass]="{ odd: odd, even: even }">
      </app-item>
    </mat-list>
  </mat-accordion>
  <p *ngIf="!items.length" class="status">{{ 'SEARCH.LABEL_ITEMS_NO_RESULTS' | translate}}</p>
</ng-container>
